import React, { useState, useEffect } from "react";
import Modal from "../../../components/ui/Modal";
import Input from "../../../components/ui/Input";
import Button from "../../../components/ui/Button";

const CreateOpportunityModal = ({ isOpen, onClose, onSave, dealToEdit }) => {
  const [advertiser, setAdvertiser] = useState("");
  const [campaign, setCampaign] = useState("");
  const [revenueShare, setRevenueShare] = useState("70/30");
  const isEditMode = !!dealToEdit;

  useEffect(() => {
    if (isEditMode && isOpen) {
      setAdvertiser(dealToEdit.advertiser || dealToEdit.brand || "");
      setCampaign(dealToEdit.campaign || dealToEdit.offer || "");
      setRevenueShare(dealToEdit.revenueShare || "N/A");
    } else {
      setAdvertiser("");
      setCampaign("");
      setRevenueShare("70/30");
    }
  }, [isOpen, dealToEdit, isEditMode]);

  const handleSaveClick = () => {
    if (!advertiser || !campaign) return;
    const dealData = {
      id: isEditMode ? dealToEdit.id : `AD-${Math.floor(Math.random() * 1000)}`,
      advertiser,
      campaign,
      revenueShare,
      status: isEditMode ? dealToEdit.status : "Draft",
      // Preserve other properties if they exist
      ...(isEditMode ? dealToEdit : {}),
    };
    onSave(dealData);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={isEditMode ? "Edit Opportunity" : "Create New Opportunity"}
    >
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">
            Advertiser / Brand
          </label>
          <Input
            value={advertiser}
            onChange={(e) => setAdvertiser(e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">
            Campaign / Offer
          </label>
          <Input
            value={campaign}
            onChange={(e) => setCampaign(e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">
            Revenue Share (Creator/Adnaki)
          </label>
          <Input
            value={revenueShare}
            onChange={(e) => setRevenueShare(e.target.value)}
          />
        </div>
        <div className="flex justify-end pt-4 space-x-3">
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSaveClick}>
            {isEditMode ? "Save Changes" : "Save Opportunity"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
export default CreateOpportunityModal;
